import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Table } from 'primeng/table';
import { CuestionariosService, GetCuestiposRequest } from '../services/cuestionarios.service';
import { SessionService } from '@shared/helpers/sesion.service';
import { MessageService } from 'primeng/api';
import { Cuestionario } from '../interfaces/cuestionario.interface';
import { NuevoTipoDialogComponent } from './nuevo-tipo-dialog.component';

@Component({
  selector: 'app-tipos-dialog',
  templateUrl: './tipos-dialog.component.html',
  providers: [MessageService]
})
export class TiposDialogComponent implements OnInit, OnChanges {
  @ViewChild('dt') table!: Table;
  @ViewChild(NuevoTipoDialogComponent) nuevoTipoDialog!: NuevoTipoDialogComponent;
  @Input() displayDialog: boolean = false;
  @Input() cuestionario: Cuestionario | null = null;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Output() onHide = new EventEmitter<{refresh: boolean, success?: boolean, error?: string}>();
  
  tipos: any[] = [];
  loading: boolean = false;
  displayNuevoTipoDialog: boolean = false;
  displayedColumns: any[] = [
    { field: 'sTipo', header: 'Tipo', sortable: true },
    { field: 'actions', header: 'Acción', sortable: false }
  ];

  constructor(
    private cuestionariosService: CuestionariosService,
    private sessionService: SessionService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    // No cargamos datos aquí, lo haremos cuando se abra el diálogo
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['displayDialog'] && changes['displayDialog'].currentValue === true) {
      this.loadData();
    }
  }

  loadData(): void {
    if (!this.cuestionario?.sClaveCues) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No se ha seleccionado un cuestionario'
      });
      this.onDialogClosed();
      return;
    }

    this.loading = true;
    const request: GetCuestiposRequest = {
      sUsuario: this.sessionService.getUserSession(),
      iAccion: 4,
      sCuest: this.cuestionario.sClaveCues,
      sTipo: ''
    };

    this.cuestionariosService.getCuestipos(request).subscribe({
      next: (response) => {
        if (response.success) {
          this.tipos = response.data;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los tipos'
          });
          this.onHide.emit({ 
            refresh: false, 
            success: false, 
            error: 'No se pudieron cargar los tipos' 
          });
        }
      },
      error: (error) => {
        console.error('Error al cargar tipos:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los tipos'
        });
        this.onHide.emit({ 
          refresh: false, 
          success: false, 
          error: 'Error al cargar los tipos' 
        });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openNew(): void {
    this.displayNuevoTipoDialog = true;
  }

  onNuevoTipoDialogClosed(event?: {refresh: boolean, success?: boolean, error?: string}): void {
    this.displayNuevoTipoDialog = false;
    if (event?.refresh) {
      this.loadData();
    }
  }

  deleteTipo(tipo: any): void {
    import('sweetalert2').then(Swal => {
      Swal.default.fire({
        title: '¿Está seguro?',
        text: `¿Está seguro de eliminar el tipo ${tipo.sTipo}?`,
        icon: 'warning',
        showCancelButton: true,
        iconColor: "#d33",
        confirmButtonColor: "#d33",
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'No',
        heightAuto: false
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.loading = true;
          const request = {
            sUsuario: this.sessionService.getUserSession(),
            iAccion: 3,
            sCuest: this.cuestionario?.sClaveCues || '',
            sTipo: tipo.sTipo
          };

          this.cuestionariosService.eliminarCuestipo(request).subscribe({
            next: (response) => {
              if (response.success && response.data.error === '0') {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Éxito',
                  detail: 'Tipo eliminado correctamente'
                });
                this.loadData();
              } else {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'No se pudo eliminar el tipo'
                });
              }
            },
            error: (error) => {
              console.error('Error al eliminar tipo:', error);
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar el tipo'
              });
            },
            complete: () => {
              this.loading = false;
            }
          });
        }
      });
    });
  }

  onDialogClosed(): void {
    this.displayDialog = false;
    this.displayDialogChange.emit(this.displayDialog);
    this.onHide.emit({ refresh: false });
  }
} 